const main = {
  'Config GMC': 'Google Merchant Center - Cài đặt Shopping Ads',
  'Config GMC Caption':
    'Công cụ tích hợp này sẽ tải dữ liệu sản phẩm của bạn thông qua Google Content API lên Google Merchant Center và cung cấp dữ liệu này cho Google Ads cũng như các dịch vụ khác của Google. Để kết nối với dịch vụ này, vui lòng liên kết ID tài khoản phụ Google Merchant Center.',
  'Merchant Center ID': 'Google Merchant ID',
  'Merchant has been saved successfully':
    'Đã lưu thành công cài đặt người bán',
  'Successfully set the Region and Language for Ads Delivery':
    'Đặt thành công Khu vực và Ngôn ngữ để Phân phối Quảng cáo',
  'Please enter numbers only': 'Vui lòng nhập ID GMC hợp lệ',
  'Config region & locale': 'Cài đặt Khu vực và Ngôn ngữ',
  'Config region & locale Caption':
    'Sau khi kết nối với Google Merchant Center, nguồn cấp dữ liệu sản phẩm thông qua Content API có thể được quản lý tại đây và sẽ được cập nhật thường xuyên. Google Merchant Center sẽ hiển thị Shopping Ads dựa trên Cài đặt Khu vực và Ngôn ngữ.',
  Region: 'Khu vực',
  Locale: 'Ngôn ngữ',
  'Add new languages to the list below': 'Thêm',
  DATA_TABLE: {
    REGION: 'Khu vực',
    LOCALE: 'Ngôn ngữ',
    ACTION: 'Bật/Tắt',
  },
  LOCALE: {
    'zh-hant': 'Tiếng Trung - Đài Loan',
    'zh-tw': 'Tiếng Trung - Đài Loan',
    'zh-hk': 'Tiếng Trung - Hồng Kông',
    'zh-cn': 'Tiếng Trung - Trung Quốc',
    en: 'Tiếng Anh',
    ms: 'Tiếng Malay',
    th: 'Tiếng Thái',
    vi: 'Tiếng Việt',
    id: 'Tiếng Indonesia',
    de: 'Tiếng Đức',
    fr: 'Tiếng Pháp',
    ja: 'Tiếng Nhật',
  },
  REGION: {
    TW: 'Đài Loan',
    CN: 'Trung Quốc',
    HK: 'Hồng Kông',
    SG: 'Singapore',
    MY: 'Malaysia',
    TH: 'Thái Lan',
    VN: 'Việt Nam',
    PH: 'Philippines',
    US: 'Mỹ',
    AU: 'Úc',
    GB: 'Anh',
  },
};

export default main;
